<template>
  <!-- click.stop: Die Zeile selbst wählt den Beteiligten ab; der Schalter
       darf die Auswahl nicht kippen. -->
  <span
    class="snt"
    :class="{ 'snt--muted': muted && !insurance, 'snt--locked': insurance, 'snt--inherit': caseMuted && !insurance }"
    @click.stop
  >
    <ParticipantNotificationToggle
      :name="name"
      :muted="muted"
      :case-muted="caseMuted"
      :insurance="insurance"
      :busy="busy"
      @toggle="$emit('toggle')"
    />
    <span class="snt__label" :title="labelTitle" @click="onLabelClick">{{ label }}</span>
  </span>
</template>

<script>
/*
  Schalter "E-Mail-Benachrichtigungen" auf einer Auswahlzeile im Dialog
  "Beteiligte zuordnen" (Kundenfeedback 27.09.2026, III: "Das müssen wir
  schon bei der Anlage abfragen und einstellen können, nicht erst im
  Nachgang").

  Wiederverwendet die Glocke der Beteiligten-Liste und ergänzt sie um eine
  kurze Beschriftung: Im Anlage-Dialog kennt niemand die Glocke schon, ein
  nacktes Icon würde übersehen – genau das Problem aus dem Feedback.
*/
import ParticipantNotificationToggle from "../components/ParticipantNotificationToggle.vue";

export default {
  name: "SelectionNotificationToggle",

  components: { ParticipantNotificationToggle },

  props: {
    /** Anzeigename – nur für den Tooltip. */
    name: { type: String, default: "" },
    /** true = dieser Beteiligte soll keine E-Mails erhalten. */
    muted: { type: Boolean, default: false },
    /** true = der ganze Fall ist stumm; der Schalter hätte keine Wirkung. */
    caseMuted: { type: Boolean, default: false },
    /** true = Versicherung; systemseitig gesperrt, kein Schalter. */
    insurance: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },

  emits: ["toggle"],

  computed: {
    label() {
      if (this.insurance) return "Keine E-Mails (Versicherung)";
      if (this.caseMuted) return "Fall ist stumm";
      return this.muted ? "Keine E-Mails" : "E-Mails an";
    },
    labelTitle() {
      if (this.insurance) {
        return "Versicherungen erhalten grundsätzlich keine Benachrichtigungen und haben keinen Zugang zu KARS";
      }
      if (this.caseMuted) {
        return "Für diesen Fall sind alle E-Mail-Benachrichtigungen ausgeschaltet";
      }
      return "E-Mail-Benachrichtigungen zu diesem Fall";
    },
    isInteractive() {
      return !this.insurance && !this.caseMuted && !this.busy;
    },
  },

  methods: {
    // Die Beschriftung ist nur eine Klickhilfe; das bedienbare Element mit
    // aria-pressed bleibt die Glocke.
    onLabelClick() {
      if (this.isInteractive) this.$emit("toggle");
    },
  },
};
</script>

<style scoped>
.snt {
  display: inline-flex; align-items: center; gap: 2px; flex-shrink: 0;
  padding-right: 8px; border-radius: 8px;
  border: 1px solid transparent; background: #fff;
  transition: background .15s, border-color .15s;
}
.snt:hover { border-color: #dbe4ef; }

.snt__label {
  font-size: 0.68rem; font-weight: 600; color: #64748b;
  white-space: nowrap; cursor: pointer; user-select: none;
}

/* Stummgeschaltet: deutlich, nicht nur "irgendwie anders". */
.snt--muted { background: #fff5f5; border-color: #fecaca; }
.snt--muted .snt__label { color: #b91c1c; }

/* Vom Fall geerbt – bedienbar erst wieder, wenn der Fall-Schalter an ist. */
.snt--inherit { opacity: 0.55; }
.snt--inherit .snt__label { cursor: default; }

/* Systemseitig gesperrt (Versicherung): neutral-grau, kein Zustand, den
   jemand gesetzt hat. */
.snt--locked { background: #f8fafc; border-color: #e2e8f0; }
.snt--locked .snt__label { color: #94a3b8; font-style: italic; cursor: help; }
</style>
